"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getHomeTenantId = exports.getTenantId = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/values"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var getTenantId = function getTenantId(userState) {
  var auth = (0, _overrideSettings.getOverrideSetting)('authImplementation');

  if (auth) {
    var _auth$user;

    return (_auth$user = auth.user()) === null || _auth$user === void 0 ? void 0 : _auth$user.tenantId;
  } else {
    return userState.user.auth !== undefined && userState.user.auth.profile !== undefined && userState.user.auth.profile.tid || undefined;
  }
};

exports.getTenantId = getTenantId;

var getHomeTenantId = function getHomeTenantId(userState) {
  var _context, _context2;

  return (0, _find.default)(_context = (0, _from.default)((0, _values.default)(_context2 = userState.user.organizationsById).call(_context2))).call(_context, function (org) {
    return org.isHomeTenant;
  });
};

exports.getHomeTenantId = getHomeTenantId;